// DAS-65 Phase 1: VariantContext
// 프로젝트가 class 컴포넌트 중심이므로 Provider는 함수형으로 구현하되
// Context.Consumer 패턴으로도 사용 가능하게 노출한다.

import React from 'react';
import {
    DEFAULT_VARIANT,
    applyVariant,
    initVariant,
    setStoredVariant,
} from '../utils/variantState';

export const VariantContext = React.createContext({
    variant: DEFAULT_VARIANT,
    setVariant: () => {},
});

/**
 * VariantProvider — 앱 루트에 삽입한다.
 * 마운트 시 initVariant()를 호출해 localStorage 로드 + DOM 속성 초기화를 수행한다.
 */
export class VariantProvider extends React.Component {
    constructor(props) {
        super(props);
        const initial = initVariant() || DEFAULT_VARIANT;
        this.state = { variant: initial };
        this.setVariant = this.setVariant.bind(this);
    }

    setVariant(v) {
        setStoredVariant(v);
        applyVariant(v);
        this.setState({ variant: v });
    }

    render() {
        const { variant } = this.state;
        return (
            <VariantContext.Provider value={{ variant, setVariant: this.setVariant }}>
                {this.props.children}
            </VariantContext.Provider>
        );
    }
}

/**
 * useVariant — 함수형 컴포넌트용 훅.
 */
export const useVariant = () => React.useContext(VariantContext);

export default VariantContext;
